import {Injectable} from '@angular/core';
import {ReportTemplateColumn} from '../../interfaces/ReportTemplateColumn';
import {environment} from '../../../../../environments/environment';
import {AuthHttp} from '../../../user/services/auth/http/auth-http.service';

@Injectable()
export class ReportFormulaTestService {
  protected route = 'template-column/test';

  constructor(private http: AuthHttp) {}

  public testColumn(column: ReportTemplateColumn) {
    return this.http.post(`${environment.baseUrl}${this.route}`, column).map((res) => res.json()).toPromise();
  }
}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/report/services/report-formula-test/report-formula-test.service.ts